<template>
    <div id="main">
        <div class="page">
            <div class="fasecultivo vertical-flow">
                <div class="listing-header">
                    <!-- TÍTULO E BREADCRUMB -->
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t("fase-cultivos") }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro-cadastros")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("fase-cultivos")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <!-- BOTÕES -->
                    <div class="header-buttons">
                        <button
                            v-if="permissao.create && !fasecultivoIntegracao"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'agro-fasecultivo-new' })
                            "
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="columns is-multiline">
                    <div class="column is-three-quarters">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                        />
                    </div>

                    <!-- SITUACAO -->
                    <div class="situacao-select column is-one-quarter">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                </div>

                <!-- LISTAGEM -->
                <div class="registry-wrapper">
                    <container-loader
                        v-if="isLoading && !$store.getters.isLoading"
                    />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="allfasecultivos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'codigo'">
                                <router-link
                                    :to="{
                                        name: 'agro-fasecultivo-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'agro-fasecultivo-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                            <div
                                v-else-if="
                                    f.key == 'excluir' &&
                                    permissao.update &&
                                    !fasecultivoIntegracao
                                "
                            >
                                <b-button
                                    class="action-button"
                                    :type="
                                        props.row['situacao'] == 1
                                            ? 'is-danger'
                                            : 'is-success'
                                    "
                                    :icon-right="
                                        props.row['situacao'] == 1
                                            ? 'delete'
                                            : 'check'
                                    "
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t(
                                        props.row['situacao'] == 1
                                            ? 'desativar'
                                            : 'reativar'
                                    )"
                                />
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t("ativo") }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t("inativo") }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FaseCultivoService from "@/services/agro/FaseCultivoService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada. 
 * Usar FaseFenologicaList ao inves.
 */

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            fasecultivoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("FASECULTIVO"),
            allfasecultivos: [],
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            service: new FaseCultivoService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: null, sortable: true, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "situacao", width: 80, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            deleteThis: null,
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            column: "descricao",
            order: "asc",
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {

        console.warn('FaseCultivoList foi depreciada. Utilize FaseFenologicaList ao inves.');

        // Seleciona o valor na posição do array de opções de paginação
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-fasecultivo"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-fasecultivo" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },

    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados(1);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allfasecultivos = value;
                    this.isEmpty = this.allfasecultivos.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar fases de cultivo.", e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                let fasecultivolist = body.content.map((mf) => {
                    return {
                        id: mf.idfasecultivo,
                        codigo: mf.idfasecultivoerp,
                        descricao: mf.descricao,
                        situacao: mf.situacao,
                    };
                });
                return fasecultivolist;
            } else {
                return [];
            }
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-agro-fasecultivo"
                    : "msg-erro-ao-reativar-agro-fasecultivo";

            let tempfasecultivo = {
                idfasecultivo: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;
            this.service
                .updateSituacao(tempfasecultivo)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-agro-fasecultivo"
                                : "msg-sucesso-ao-reativar-agro-fasecultivo";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.page {
    position: relative;
    padding-left: 0;

    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>
